import type { InfiniteData } from '@tanstack/react-query'

export type OpportunityParticipant = {
  id: string
  accountId: string
  fullName: string
  preferredName: string | null
  image: string | null
  email?: string | null
  notificationEmails?: string[]
  participationStatus?: string
}

export type AttendeesListProps = {
  data?: InfiniteData<OpportunityParticipant[]>
  displayEmailAddresses?: boolean
  hideAvatars?: boolean
  actionButton?: {
    label: string
    onClick: (attendee: OpportunityParticipant) => void
  }
}
